<template>
  <div>
    <SystemNotification :notice-key="'vacation_notice'"/>
    <p class="page__heading-text"><strong>Thank you, we received
      <router-link :to="{ name: 'orders', params: { id: $route.params.id }}">your order
      </router-link>
      !</strong>
      You will be updated about the progress of your order to <a href="#" title="#"><strong
        v-if="profile">{{ profile.email }}</strong></a>.
      If anything comes up while checking your order, we’ll contact you to clarify.
      In the meantime, you can view your order status under ‘Orders’ in ‘My Account’, found in the
      top right corner of the page.
    </p>
    <p class="page__heading-text">
      <router-link :to="{name: 'landing'}" class="button button--blue-a">
                <span class="button__text">
                    Browse more products
                </span>
      </router-link>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SystemNotification from '../SystemNotification.vue';

export default {
  components: { SystemNotification },
  computed: {
    ...mapGetters({
      profile: 'profile/profile',
    }),
  },
};
</script>
